export default __webpack_public_path__ + "static/media/round.c343a36f.svg";